import { Fragment } from 'react';

import { ScrollableContainer, ScrollableItem } from '@hh.ru/magritte-ui';
import { BreakpointSwitcher } from '@hh.ru/magritte-ui-breakpoint';

import Item from 'src/pages/HhProPromo/components/About/Item';

import styles from './styles.less';

const ABOUT_INDEX = [1, 2, 3] as const;

const About: React.FC<{ tariffId: string }> = ({ tariffId }) => {
    const renderItems = (slider?: boolean) => {
        const Wrapper = slider ? ScrollableItem : Fragment;
        return (
            <div
                className={styles.aboutWrapper}
                style={
                    slider
                        ? { width: `calc(65% * ${ABOUT_INDEX.length} + 12px * ${ABOUT_INDEX.length - 1})` }
                        : undefined
                }
            >
                {ABOUT_INDEX.map((index) => {
                    return <Item Wrapper={Wrapper} blockNumber={index} tariffId={tariffId} key={index} />;
                })}
            </div>
        );
    };

    return (
        <BreakpointSwitcher
            default={
                <ScrollableContainer disableButtons correctionS={56} correctionXS={16}>
                    {renderItems(true)}
                </ScrollableContainer>
            }
            gteS={renderItems()}
        />
    );
};

export default About;
